<template>
  <div
    class="single-svg"
    :class="[
		fullpage ? 'fullpage' : '',
		fullHeight ? 'full-height' : '',
		verticalPadding ? 'vertical-padding' : '',
		noPadding ? 'no-padding' : '',
		noPaddingTop ? 'no-padding-top' : '',
		noPaddingBottom ? 'no-padding-bottom' : '' ]"
    :style="{'background': bgColor, 'padding-bottom': noPaddingBottom}"
  >
    <h2 :style="{color: textColor}">{{ text }}</h2>
    <div
      class="parallax"
      v-observe-visibility="parallax"
      v-html="this.svg"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import LazyLoad from "vanilla-lazyload";

export default {
  name: "SvgImage",
  props: {
    bgColor: String,
    image: String,
    fullpage: Boolean,
    fullHeight: Boolean,
    maxWidth: Number,
    verticalPadding: Boolean,
    noPadding: Boolean,
    noPaddingTop: Boolean,
    noPaddingBottom: Boolean,
    noParallax: Boolean,
    text: String,
    textColor: String
  },
  data() {
    return {
      lastScroll: null,
      imageWidth: this.maxWidth,
      imageSizeRatio: 0,
      svg: false
    };
  },
  computed: mapState({
    currentScroll: state => state.globals.currentScroll,
    isMobile: state => state.isMobile
  }),
  watch: {
    isMobile() {
      this.toggleWidth(this.isMobile);
    }
  },
  methods: {
    toggleWidth(isMobile) {
      this.imageWidth = isMobile ? 100 : this.maxWidth;
    },
    parallax(isVisible, entry) {
      if (!this.bgColor) return;

      const windowHeight = window.innerHeight;

      if (!this.noParallax) this.doParallax(entry, windowHeight);
    },
    doParallax(entry, windowHeight) {
      requestAnimationFrame(this.doParallax.bind(null, entry, windowHeight));
      if (this.lastScroll === this.currentScroll) return;

      const bounds = entry.target.getBoundingClientRect();
      const percentInView =
        1 -
        Math.max(
          0,
          Math.min(1, bounds.bottom / (windowHeight + bounds.height))
        );
      const transform = (-0.5 + percentInView) * -20;

      Object.assign(entry.target.style, {
        transform: `translate3d(0, ${transform}%, 0)`
      });

      this.lastScroll = this.currentScroll;
    }
  },
  mounted() {},
  created() {
    this.svg = require(`./../assets${this.image}`);
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.single-svg {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $margin2-1;
  position: relative;
  @media screen and (max-width: 1024px) {
    padding: $margin1-1;
  }
  @media screen and (max-width: 768px) {
    padding: $margin1-1 $margin1-2;
  }

  h2 {
    position: absolute;
    top: 7.3vw;
    left: 9.3vw;
    font-size: $font-size-s;
    font-family: $font-expanded;
    z-index: 2;

    @media screen and (max-width: 940px) {
      font-size: $font-size-xs;
    }
    @media screen and (max-width: 550px) {
      font-size: $font-size-xxs;
      top: 6vw;
    }
    @media screen and (max-width: 440px) {
      font-size: $font-size-xxs;
      left: 20px;
    }
  }

  .parallax {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.max-width {
      max-width: 1560px;
    }

    svg {
      position: relative;
      width: 100%;
    }
  }

  &.fullpage {
    padding: 0;
  }

  &.full-height {
    min-height: 100vh;
    box-sizing: border-box;
  }

  &.vertical-padding {
    padding: $margin1-1 0;
    @media screen and (min-width: 769px) {
      padding: $margin2-1;
    }
  }

  &__wrapper {
    width: 100%;
    height: auto;

    background: center / cover no-repeat;
  }
}
</style>

